import { useState } from 'react';
import { getWorkspaceLogo, getWorkspaceInitials, getWorkspaceColor } from '../utils/workspaceUtils';

interface UseWorkspaceAvatarProps {
  volumeName: string;
  shortName: string;
}

interface UseWorkspaceAvatarReturn {
  logoUrl: string;
  initials: string;
  backgroundColor: string;
  imageError: boolean;
  handleImageError: () => void;
  showImage: boolean;
}

export const useWorkspaceAvatar = ({ volumeName, shortName }: UseWorkspaceAvatarProps): UseWorkspaceAvatarReturn => {
  const [imageError, setImageError] = useState(false);

  const logoUrl = getWorkspaceLogo(volumeName);
  const initials = getWorkspaceInitials(shortName);
  const backgroundColor = getWorkspaceColor(shortName);

  const handleImageError = () => setImageError(true);
  const showImage = Boolean(logoUrl && !imageError);

  return {
    logoUrl,
    initials,
    backgroundColor,
    imageError,
    handleImageError,
    showImage,
  };
};
